import { create } from 'zustand';
import type { ProjectsViewMode } from '@shared/types';
import { useShellStore } from '@renderer/app/state/shell-store';

export type ResourcesCategoryFilter = 'all' | 'documents' | 'images' | 'icons';
export type ResourcesSort = 'recent' | 'oldest' | 'name_asc' | 'name_desc';

interface ResourcesViewStore {
  categoryFilter: ResourcesCategoryFilter;
  projectFilter: 'all' | string;
  sort: ResourcesSort;
  query: string;
  setCategoryFilter: (value: ResourcesCategoryFilter) => void;
  setProjectFilter: (value: 'all' | string) => void;
  setSort: (value: ResourcesSort) => void;
  setQuery: (value: string) => void;
  setViewMode: (value: ProjectsViewMode) => Promise<void>;
}

export const useResourcesViewStore = create<ResourcesViewStore>((set) => ({
  categoryFilter: 'all',
  projectFilter: 'all',
  sort: 'recent',
  query: '',
  setCategoryFilter: (categoryFilter) => set({ categoryFilter }),
  setProjectFilter: (projectFilter) => set({ projectFilter }),
  setSort: (sort) => set({ sort }),
  setQuery: (query) => set({ query }),
  setViewMode: async (resourcesViewMode) => {
    await useShellStore.getState().savePreferences({ resourcesViewMode });
  }
}));
